import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './AppShell.module.css';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

// The login page renders bare (no chrome). Every other authenticated route
// gets the sidebar + header layout.
const BARE_PATHS = new Set<string>(['/login']);

export function AppShell({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (BARE_PATHS.has(location.pathname)) {
    return <>{children}</>;
  }
  return (
    <div className={styles.shell}>
      <div className={styles.header}>
        <Header />
      </div>
      <aside className={styles.sidebar}>
        <Sidebar />
      </aside>
      <main className={styles.content}>
        <div className={styles.contentInner}>{children}</div>
      </main>
    </div>
  );
}
